import { render, staticRenderFns } from "./resourcesdialog.vue?vue&type=template&id=03374753&scoped=true"
import script from "./resourcesdialog.vue?vue&type=script&lang=js"
export * from "./resourcesdialog.vue?vue&type=script&lang=js"
import style0 from "./resourcesdialog.vue?vue&type=style&index=0&id=03374753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03374753",
  null
  
)

export default component.exports